export class UsersIDRequestModel
{
    UsersIDs:number[]=[]
}